import axios from "axios";
import { GET_CORONA_LIST, ADD_CORONA } from "../constant";

const { decorate, observable, action } = require("mobx");
class Corona {
  list = [];
  isLoading = false;
  async getList() {
    try {
      this.isLoading = true;
      let response = await axios.get(GET_CORONA_LIST);
      let data = await response.data;
      this.list = data;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw error;
    }
  }

  async addCorona(groupid, title) {
    try {
      this.isLoading = true;
      let response = await axios.post(ADD_CORONA, {
        groupid: groupid,
        title: title,
      });
      await this.getList();
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw error;
    }
  }
}

decorate(Corona, {
  list: observable,
  getList: action,
  addCorona: action,
});

const init = new Corona();
export default init;
